import { getApiFilters, getSearchParams } from '@react/search/helpers';
import { populate } from '@sly/core/constants/populate';
import ProviderPage from 'sly/provider/components/ProviderPageContainer';
import { createApiClient } from 'sly/services/api';
import apiEndpoints from 'sly/services/api/endpoints';

export default ProviderPage;

export async function getServerSideProps({ query }) {
  const { api, store } = createApiClient(apiEndpoints);

  const currentFilters = getSearchParams(query);
  const apiFilters = getApiFilters(currentFilters);

  const [_, providerPromise] = await Promise.allSettled(
    [
      api.getSearchPage.asAction({
        ...apiFilters,
        'filter[partnerCollection]': query.slug,
      }),
      api.getProviderPage.asAction({
        'filters[providerSlug][$eq]': query.slug,
        populate: populate.providerPage,
      }),
      api.getCommunityPartner.asAction({
        id: query.slug,
      }),
      api.getEntityReviews.asAction({
        entityType: 'partner-collection',
        id: query.slug,
        'filter[value]': 'gt:3',
        sort: 'created_at',
        include:
          'searchResource,statusByUser,searchResource.gallery,searchResource.gallery.images',
      }),
    ].map(store.dispatch)
  );

  if (providerPromise?.reason?.status === 301) {
    return {
      redirect: {
        destination: providerPromise?.reason?.headers?.location,
        permanent: true,
      },
    };
  } else if (providerPromise?.value?.body?.data?.length === 0) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      initialApiState: store.getState(),
    },
  };
}
